// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type ContrastIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from contrast.svg
 */
export default function ContrastIcon(props: ContrastIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="ContrastIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M16 8c0-4.052-3.948-8-8-8S0 3.948 0 8s3.948 8 8 8 8-3.948 8-8m-2 0c0 2.948-3.052 6-6 6V2l.201.005C11.085 2.139 14 5.119 14 8"
        />
      </g>
    </svg>
  );
}
